export const /** SideBar Styles */ sideBarStyles = {
    sideBarItem: (routeTabId, tabId) => ({
        borderRadius: '100px',
        backgroundColor: parseInt(routeTabId || '0') === tabId ? 'greenLight.main' : 'none',
        textAlign: 'center',
        padding: '0.25rem 1rem',
        '&:hover': {
            backgroundColor: parseInt(routeTabId || '0') === tabId ? 'greenLight.main' : 'none',
        },
        minWidth: '0',
    }),
    sideBarItemName: {
        letterSpacing: '0.03125rem',
        fontWeight: 'medium',
        margin: '0',
    },
};
